var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { staticClass: "notifications-container", attrs: { name: "notification" } },
    _vm._l(_vm.notifications, function(notification, index) {
      return _c(
        "div",
        {
          key: notification.key,
          staticClass: "notification",
          on: {
            click: function($event) {
              return _vm.removeNotification(index)
            }
          }
        },
        [
          _c("div", { staticClass: "info" }, [
            _c("img", { attrs: { src: _vm.imageUrl("check.svg") } }),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _vm._v(_vm._s(notification.notification))
            ])
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-616df4be", { render: render, staticRenderFns: staticRenderFns })
  }
}